import { REVIEWS } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5 text-accent-600">
      {Array.from({ length: 5 }).map((_, i) => (
        <i key={i} className={i < count ? "ri-star-fill" : "ri-star-line"} />
      ))}
    </div>
  );
}

export default function Reviews() {
  return (
    <section id="reviews" className="relative scroll-mt-20 overflow-hidden bg-accent-100/50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            kicker="用户口碑"
            title={
              <>
                他们说，<span className="text-primary-600">这瓜是真香</span>
              </>
            }
            desc="来自资深瓜友与麦上常客的真实声音，很多故事，都是在这里从围观开始的。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {REVIEWS.map((r, idx) => (
            <Reveal key={r.name} delay={idx * 90}>
              <figure className="flex h-full flex-col rounded-3xl border border-accent-200 bg-background-50 p-6">
                <Stars count={r.stars} />
                <blockquote className="mt-4 flex-1 text-sm leading-7 text-foreground-700">
                  “{r.text}”
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-primary-200 to-accent-200 text-lg font-bold text-primary-700">
                    {r.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-950">{r.name}</p>
                    <p className="text-xs text-foreground-500">{r.role}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}